import type { GridFilterModel } from "@mui/x-data-grid";

export const getSerialNumberFilterSearch = (serialNumber: string): string => {
  const filterModel: GridFilterModel = {
    items: [
      {
        id: "device-serial-number",
        field: "serialNumber",
        operator: "equals",
        value: serialNumber,
      },
    ],
  };

  return `?${new URLSearchParams({ filters: JSON.stringify(filterModel) }).toString()}`;
};
